import React from 'react'
import PropTypes from 'prop-types'
import ParentRow from './ParentRow'
import GroupChild from './GroupChild'

class ItemRow extends React.Component {
    render() {
        const {index, item, isSelected, reloadItems, openModalEdit, openModalEditProduct, onChangeSelected, openModalMarkFaileDesign, itemsRequest, onModalItemLabel, onChangeFilterTag, openModalGenLabelCustomWHL, filter, onChangeFilter} = this.props
        
        return (
            <React.Fragment>
                <ParentRow
                    index={index}
                    isSelected={isSelected}
                    item={item}
                    reloadItems={reloadItems}
                    openModalEdit={openModalEdit}
                    openModalEditProduct={openModalEditProduct}
                    openModalMarkFaileDesign={openModalMarkFaileDesign}
                    onChangeSelected={onChangeSelected}
                    orderNote={item.note}
                    itemsRequest={itemsRequest}
                    onModalItemLabel={onModalItemLabel}
                    onChangeFilterTag={onChangeFilterTag}
                    openModalGenLabelCustomWHL={openModalGenLabelCustomWHL}
                    filter={filter}
                    onChangeFilter={onChangeFilter}
                />
                <GroupChild
                    index={index}
                    item={item}
                    openModalMarkFaileDesign={openModalMarkFaileDesign}
                    openModalEditProduct={openModalEditProduct}
                    reloadItems={reloadItems}
                    itemsRequest={itemsRequest}
                    onChangeFilterTag={onChangeFilterTag}
                    filter={filter}
                    onChangeFilter={onChangeFilter}
                />
            </React.Fragment>
        )
    }
}

ItemRow.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    reloadItems: PropTypes.func.isRequired,
}

export default ItemRow
